import {OvereasProcessor} from "../OvereasProcessor";
import {AbstractModule} from "../AbstractModule";
import {AdminTable} from "./AdminTable";
import {OrderPage} from "./OrderPage";

export class AdminControls extends AbstractModule {
    protected adminTable: AdminTable = null;
    protected orderPage: OrderPage = null;

    constructor(plugin: OvereasProcessor) {
        super(plugin);
    }

    public init() {
        if (this.plugin.$("body").hasClass("woocommerce_page_overseas_reports") === true) {
            this.adminTable = new AdminTable(this.plugin);
            return;
        }
        else if (this.plugin.$("select#os-payment-gateway").length !== 0) {
            this.orderPage = new OrderPage(this.plugin);
            return;
        }

        if (this.plugin.$("#woocommerce_overseas_processor_enabled, #woocommerce_overseas_processor_gatewayName").length === 0)
            return; // not our plugin settings page
        this.plugin.getTooltips().initToolTips();
        this.initForm();
        this.addButtonEvents();
        this.hideTokensInputRow("#woocommerce_overseas_processor_token");
        this.addSubmitHandler();
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected initForm() {
        if (this.plugin.$("#woocommerce_overseas_processor_availableGateways option").length === 0)
            this.plugin.$("#overs-edit-gateway").addClass("disabled");
        this.plugin.$(".woocommerce table.form-table textarea.input-text").removeClass("wide-input"); // workaround to not show it on full screen width
        //this.showTestGatewayButton();
    }

    protected addButtonEvents() {
        // Main page
        this.plugin.$("#overs-add-gateway").on("click", (event) => {
            //if (this.plugin.$(event.target).hasClass("disabled") === true)
                //return;
            let url = this.webHelpers.addParamToUrl(this.plugin.window.document.location.href, "overs-p", "add");
            url = this.webHelpers.addParamToUrl(url, "overs-reset", "1");
            this.plugin.window.location.href = url;
        });
        this.plugin.$("#overs-edit-gateway").on("click", (event) => {
            if (this.plugin.$("#woocommerce_overseas_processor_availableGateways option").length === 0)
                return;
            let url = this.webHelpers.addParamToUrl(this.plugin.window.document.location.href, "overs-p", "edit");
            let gatewayToken = this.plugin.$("#woocommerce_overseas_processor_availableGateways").val();
            if (!gatewayToken) {
                this.plugin.window.alert(this.plugin.getAdminConfig().tr.noGateway);
                return;
            }
            url = this.webHelpers.addParamToUrl(url, "overs-t", gatewayToken);
            this.plugin.window.location.href = url;
        });

        // Gateway page
        /*
        this.plugin.$("#woocommerce_overseas_processor_gateway").on("change", (event) => {
            this.showTestGatewayButton();
        });*/
        this.plugin.$("#overs-remove-gateway").on("click", (event) => {
            if (this.plugin.window.confirm(this.plugin.getAdminConfig().tr.confirmRemoveGateway) === false)
                return;
            let url = this.plugin.window.document.location.href.replace(/&overs-p=[a-z0-9]+/i, "");
            //url = url.replace(/&overs-t=[a-z0-9]+/i, ""); // token must be kept to know which gateway is to be removed
            url = this.webHelpers.addParamToUrl(url, "overs-a", "remove");
            this.plugin.window.location.href = url;
        });
        this.plugin.$("#overs-test-gateway").on("click", (event) => {
            let url = this.plugin.window.document.location.href.replace(/&overs-a=[a-z0-9]+/i, "");
            url = this.webHelpers.addParamToUrl(url, "overs-a", "test");
            this.plugin.window.location.href = url;
        });
        this.plugin.$("#overs-back").on("click", (event) => {
            let url = this.plugin.window.document.location.href.replace(/&overs-p=[a-z0-9]+/i, "");
            url = url.replace(/&overs-t=[a-z0-9]+/i, "");
            this.plugin.window.location.href = url;
        });
    }

    /*
    protected showTestGatewayButton() {
        const selectedGateway = this.plugin.$("#woocommerce_overseas_processor_gateway").val();
        if (selectedGateway === "Y") // PayPal
            this.plugin.$("#overs-test-gateway").removeAttr("disabled");
        else
            this.plugin.$("#overs-test-gateway").attr("disabled", "disabled");
    }*/

    /**
     * Hides the whole table row of an (input) element we only use to send data on form submit.
     * @param inputSelector
     */
    protected hideTokensInputRow(inputSelector: string) {
        if (this.plugin.$(inputSelector).length === 0)
            return;
        let parent = this.plugin.$(inputSelector).parent();
        const max = 1000;
        let i = 0;
        while (parent.prop("tagName") !== "TR")
        {
            parent = parent.parent();
            i++;
            if (i >= max) {
                this.plugin.window.console.error("Overseas Payments: Unable to find <tr> tag in WooCommerce settings. Most likely WC HTML changed on update.");
                break;
            }
        }
        parent.addClass("hidden");
    }

    protected addSubmitHandler() {
        this.plugin.$("#mainform").on("submit", (event) => {
            // TODO add client-side validation?
            this.plugin.$("#woocommerce_overseas_processor_conversionRate").remove(); // don't submit it
            // must be enabled so that it gets submitted
            this.plugin.$("#mainform input").removeAttr("disabled");
        });
    }
}
